import axios from "axios";
import { songApproverApi } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function songApproverEdit(songId,postData) 
{
        const response=await axios.put(
        songApproverApi.UPDATE+songId+"/",
        postData,
        {
            headers:{
                Authorization: 'Token '+getSelfToken(),
            },
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        return error.response;
        });
        return response;
   
} 
